import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { AuthenticationResolver } from './AuthenticationResolver';
import { AMCAuth0Service } from '../../services/authentication/amc/amc-auth0.service';

@Injectable()
export class AMCAuthenticationResolver extends AuthenticationResolver {
  constructor(windowService: WindowService, private auth0Service: AMCAuth0Service) {
    super(windowService);
  }

  // can we get PII infor here too and save it in the auth0 controller?
  async resolve(): Promise<void> {
    // TODO: clean this process up yo https://massmutual.atlassian.net/browse/HL-21138
    const isAuth0enabled = await this.auth0Service.getIsAuth0Enabled();

    await this.windowService.nativeWindow.controller.resolveHeavyUserFeature();

    if (isAuth0enabled) {
      // snag this info before the app or other components loads
      await this.auth0Service.getAMCUserInfo();
      if (this.auth0Service.isAMCheavyUser) {
        await this.auth0Service.getHeavyUserAMCdata();
      }
    }
    super.resolve();
  }
}
